import {RoundNumericReplaceConfig} from '../types/get-round-numeric.pipe.types';

/**
 * Configuration object for GetRoundNumericPipe
 * Provides static properties and methods to handle replacements of specific values in numeric transformations
 */
export class GetRoundNumericPipeConfig {
  /**
   * Array of null and undefined values that should be replaced
   * @public
   */
  public static readonly NullToReplace: any[] = [null, undefined];

  /**
   * Array of null, undefined and zero values that should be replaced
   * @public
   */
  public static readonly NullAndZeroToReplace: any[] = [null, undefined, 0];

  /**
   * Default configuration to replace null or undefined values with an empty string
   * @public
   */
  public static readonly NullToEmptyReplaceConfig: RoundNumericReplaceConfig = {
    ToReplace: GetRoundNumericPipeConfig.NullToReplace,
    ReplaceWith: ''
  };

  /**
   * Default configuration to replace null, undefined or zero values with an empty string
   * @public
   */
  public static readonly NullAndZeroToEmptyReplaceConfig: RoundNumericReplaceConfig = {
    ToReplace: GetRoundNumericPipeConfig.NullAndZeroToReplace,
    ReplaceWith: ''
  };

  /**
   * Creates a custom replacement configuration
   * @param toReplace - Array of values that should be replaced
   * @param replaceWith - String value to use as replacement
   * @returns RoundNumericReplaceConfig with specified replacement settings
   * @public
   */
  public static createCustomReplaceConfig(toReplace: any[], replaceWith: string): RoundNumericReplaceConfig {
    return { ToReplace: toReplace, ReplaceWith: replaceWith };
  }
}
